module.exports = __webpack_public_path__ + "img/slide-10.979d197b.jpg";